import { render, staticRenderFns } from "./ManageRates.vue?vue&type=template&id=15e2f614"
import script from "./ManageRates.vue?vue&type=script&lang=ts"
export * from "./ManageRates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports